import { AppMode } from 'app/store/general/AppMode';
import { WidgetDropdownItem, WidgetsService } from 'widgets/WidgetsService';
import orderBy from 'lodash/orderBy';
import { WidgetHost } from 'widgets/WidgetRegistry';

export enum WidgetCategory {
    TOP = 'top',
    SINGLE_STOCK = 'singleStock',
    MULTIPLE_STOCK = 'multipleStock',
    PORTFOLIO = 'portfolio',
    PRICE_CAPSULES = 'price',
    FILL_CAPSULES = 'fills',
    VOLUME_CAPSULES = 'volume',
    SIGNAL_CAPSULES = 'signals',
}

const categoryTitles: Record<WidgetCategory, string> = {
    [WidgetCategory.TOP]: '',
    [WidgetCategory.SINGLE_STOCK]: 'Single Stock',
    [WidgetCategory.MULTIPLE_STOCK]: 'Multi-Stock',
    [WidgetCategory.PORTFOLIO]: 'Portfolio',
    [WidgetCategory.PRICE_CAPSULES]: 'Price',
    [WidgetCategory.FILL_CAPSULES]: 'Fills',
    [WidgetCategory.VOLUME_CAPSULES]: 'Volume',
    [WidgetCategory.SIGNAL_CAPSULES]: 'Signals',
};

export interface AppModeWidgetCategory {
    appModes: AppMode[];
    categories: WidgetCategory[];
}

export interface WidgetDropdownCategory {
    title: string;
    category: WidgetCategory;
}

export const widgetDropdownCategory: (
    category: WidgetCategory
) => WidgetDropdownCategory = (category) => ({
    category,
    title: categoryTitles[category],
});

export function getCategoriedWidgets(
    widgetsService: WidgetsService,
    appMode: AppMode,
    host: WidgetHost,
    dropdownCategories: WidgetDropdownCategory[]
): Array<{
    category: WidgetDropdownCategory;
    options: WidgetDropdownItem[];
}> {
    const availableWidgets = widgetsService.getTitles(appMode, host);

    return dropdownCategories.map((c) => ({
        category: c,
        options: getSortedCategory(availableWidgets, c),
    }));

    function getSortedCategory(
        widgets: WidgetDropdownItem[],
        category: WidgetDropdownCategory
    ) {
        const filteredWidgets = widgets.filter(
            (w) => w.categories?.includes(category.category)
        );

        return orderBy(filteredWidgets, ['title']);
    }
}
